import React, { Component } from 'react';
import './WatchButton.scss';
import helpers from '../../../helpers';

class WatchButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active: false,
      link: ''
    };
  }

  componentDidMount() {
    window.addEventListener('changeTheme', this.update.bind(this));
    this.update();
  }

  componentWillUnmount() {
    window.removeEventListener('changeTheme', this.update.bind(this));
  }

  trackClick() {
    if (typeof window.tracker === 'undefined') {
      return false;
    }

    return window.tracker.click({
      click_type: 'exit',
      click_name: 'miniplayer_kijklive',
      chapter_1: 'nederlandfm',
      chapter_2: helpers.getMiniplayer(this).getTheme()
    });
  }

  update() {
    helpers
      .getChannelInfo(this.props.channel) // eslint-disable-line
      .then(
        channelInfo => {
          if (channelInfo.videoplayer) {
            this.setState({ active: true, link: channelInfo.videoplayer });
          } else {
            this.setState({ active: false, link: '' });
          }
        },
        error => {
          throw new Error(error);
        }
      );
  }

  render() {
    const { active, link } = this.state;

    if (!active) {
      return null;
    }

    return (
      <a
        className="WatchButton clickitem"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
        onClick={this.trackClick.bind(this)}
      >
        <svg viewBox="0 0 16 10">
          <g>
            <path d="M9.4795968,0 L2.02041187,0 C0.906585159,0 0,0.960037209 0,2.13953488 L0,7.86046512 C0,9.03996279 0.906585159,10 2.02041187,10 L9.4795968,10 C10.5110786,10 11.373689,9.18169302 11.4870078,8.09674419 L11.4904389,1.97469767 L11.4870078,1.90347721 C11.3737716,0.818453953 10.5111137,0.000221395349 9.4795968,0.000221395349 L9.4795968,0 Z M10.2605826,7.98474419 C10.2036211,8.39317209 9.87283923,8.69767442 9.4795968,8.69767442 L2.02041187,8.69767442 C1.58461781,8.69767442 1.22981592,8.32195349 1.22981592,7.86046512 L1.22981592,2.13953488 C1.22981592,1.67804651 1.58461781,1.30232558 2.02041187,1.30232558 L9.4795968,1.30232558 C9.87283923,1.30232558 10.2043098,1.60682791 10.2605826,2.01525581 L10.2605826,7.98474419 Z M15.1668454,0.934511628 C14.6686118,0.672893023 14.035854,0.736837209 13.5938933,1.09221581 L12.0106458,2.45340651 L12.0106458,4.13072744 L14.3425525,2.12496 C14.422162,2.06391442 14.5305913,2.05446512 14.6198057,2.10097674 C14.7117678,2.14966884 14.7694146,2.2477786 14.7694146,2.35751628 L14.7694146,7.63509767 C14.7694146,7.74410977 14.712453,7.84222326 14.6191188,7.89091163 C14.5299026,7.9381507 14.422155,7.92797581 14.3418655,7.86692837 L12.0099589,5.86116093 L12.0099589,7.53848186 L13.5774295,8.88586791 L13.5932151,8.89894884 C13.8608582,9.11405581 14.1779223,9.22380465 14.4984123,9.22380465 C14.7248917,9.22380465 14.9541118,9.16857116 15.1668524,9.05665302 C15.6808803,8.78703442 15.9993148,8.24197395 15.9993148,7.63442047 L16,2.35758326 C16,1.75002977 15.6808803,1.2049693 15.1668524,0.934625116 L15.1668454,0.934511628 Z" />
          </g>
        </svg>
        <span>Kijk live</span>
      </a>
    );
  }
}

export default WatchButton;
